module.exports = __webpack_public_path__ + "e53a2b9c853f7dbbf35d13e99988bb9e.wasm";